module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.disabled) ? _c('el-dialog', {
    ref: "relateDialog",
    attrs: {
      "title": _vm.source.title,
      "visible": _vm.dialogShow
    }
  }, [_c('el-table', {
    ref: "selectTable",
    attrs: {
      "data": _vm.tableData
    }
  }, _vm._l((_vm.visibleFields), function(field) {
    return _c('el-table-column', {
      attrs: {
        "prop": field.field_name,
        "label": field.show_name
      }
    })
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-532994c7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/instance/deal/relateDeal.vue
// module id = 1866
// module chunks = 2